import React from "react";
import { X } from "react-feather";
import { useIntl } from "react-intl";
import useYoutubeTracker from "../hooks/useYoutubeTracker";

const IntroVideo = ({ onClose }) => {
  const { formatMessage } = useIntl();
  const { trackVideoEvents } = useYoutubeTracker("intro-video");

  return (
    <>
      <div className="modal large is-active">
        <div className="modal-background" onClick={onClose}></div>
        <div className="modal-card" id="modal-intro-video">
          <header className="modal-card-head">
            <div className="modal-card-title">
              {formatMessage({ id: "titulo-intro-video" })}
            </div>
            <X
              role="button"
              title={formatMessage({ id: "fechar" })}
              className="close-button"
              onClick={onClose}
            />
          </header>
          <section className="modal-card-body">
            <iframe
              id="intro-video"
              title="Intro BusCAR"
              src="https://www.youtube.com/embed/_zU3xDu5fLE?enablejsapi=1"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </section>
        </div>
      </div>

      {trackVideoEvents()}
    </>
  );
};

export default IntroVideo;
